import e from "./_isKeyable.js";
var i = e;
function p(r, a) {
  var t = r.__data__;
  return i(a) ? t[typeof a == "string" ? "string" : "hash"] : t.map;
}
var _ = p;
export {
  _ as default
};
//# sourceMappingURL=_getMapData.js.map
